import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles } from './template.scss';
import { ImageState } from '../../../ui/gzImageRepo/types';
import { FontSizes } from "../../../types/common/types";

export const templateRiskIncidentSidePanel = document.createElement('template');

templateRiskIncidentSidePanel.innerHTML = `
  <style>${styleHelpers}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <div class="title-header">
    </div>
    <gz-input-search id="risk-incident-side-panel-input-search" type="text" maxlength="100"></gz-input-search>
    <div id="risk-incident-side-panel-accordions"></div>
    <div id="license-required" class="hidden">
      <gz-image-repo class="mt-10" state="${ImageState.EMPTY}">
        <gz-title fontSize='${FontSizes.HEADING_4}' id="license-required-title"></gz-title>
        <gz-text id="license-required-message" fontSize="14" lineHeight="1"></gz-text>
        <gz-button id='get-license' color="primary" type="quiet"  buttonheight="small" buttonfontsize="small">
        </gz-button>
      </gz-image-repo>
    </div>
  </div>
`;

templateRiskIncidentSidePanel.style.height = '100%';
